<template>
  <editor-content class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-slate-500 focus:border-slate-500 sm:text-sm dark:bg-gray-900 dark:text-white" :editor="editor" />
</template>



<script>
import { Editor, EditorContent } from "@tiptap/vue-3";
import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";
import Highlight from "@tiptap/extension-highlight";
import Typography from "@tiptap/extension-typography";
import { onBeforeUnmount, onMounted, ref, watch } from "vue";

export default {
  components: {
    EditorContent,
  },

  props: {
    modelValue: {
      type: String,
      default: "",
    },
  },

  setup(props, { emit }) {
    const editor = ref(null);
    onMounted(() => {
      editor.value = new Editor({
        content: props.modelValue,
        extensions: [StarterKit, Highlight, Typography, Placeholder],
        onUpdate: () => {
          emit("update:modelValue", editor.value.getHTML());
        },
      });
    });

    watch(
      () => props.modelValue,
      (value) => {
        const isSame = editor.value.getHTML() === value;

        if (isSame) {
          return;
        }

        editor.value.commands.setContent(props.modelValue, false);
      }
    );
    onBeforeUnmount(() => {
      editor.value.destroy();
    });

    return {
      editor,
    };
  },

  // watch: {
  //   modelValue(value) {
  //     const isSame = this.editor.getHTML() === value;

  //     if (isSame) {
  //       return;
  //     }

  //     this.editor.commands.setContent(this.modelValue, false);
  //   },
  // },

  // mounted() {
  //   this.editor = new Editor({
  //     content: this.modelValue,
  //     extensions: [StarterKit, Highlight, Typography, Placeholder],
  //     onUpdate: () => {
  //       this.$emit("update:modelValue", this.editor.getHTML());
  //     },
  //   });
  // },

  // beforeUnmount() {
  //   this.editor.destroy();
  // },
};
</script>

<style>
.ProseMirror {
  padding: 1em;
  min-height: 60px;
}
.ProseMirror p.is-editor-empty:first-child::before {
  /* content: attr(data-placeholder); */
  content: "Write or paste a highlight";
  float: left;
  color: #ced4da;
  pointer-events: none;
  height: 0;
}
</style>
